$(document).on('change', 'input[name="contact_preferences[]"]', function(e) {
  enabledPreferences();
});

if ($('input[name="contact_preferences[]"]').length > 0) { 
  enabledPreferences();
}

function enabledPreferences() {
  var enabledPreferences = [];

  $('input[name="contact_preferences[]"]:checked').each(function() {
    enabledPreferences.push($(this).val());
  });

  var $emailField = $('form.contact-preferences input[name="contact_email"]'),
    $phoneField = $('form.contact-preferences input[name="contact_phone"]');

  if (enabledPreferences.indexOf('phone') !== -1) {
    $phoneField.addClass('required');
    $phoneField.parents('.field-wrap').removeClass('field-wrap-disabled');
  } else {
    $phoneField.removeClass('required');
    $phoneField.parents('.field-wrap').addClass('field-wrap-disabled');
  }

  if (enabledPreferences.indexOf('email') !== -1) {
    $emailField.addClass('required');
    $emailField.parents('.field-wrap').removeClass('field-wrap-disabled');
  } else {
    $emailField.removeClass('required');
    $emailField.parents('.field-wrap').addClass('field-wrap-disabled');
  }

  $emailField.valid();
  $phoneField.valid();
}

/** Update user contact preferences */
$(document).on('submit', '.contact-preferences', function(e) {
  e.preventDefault();

  var $form = $(this),
    formData = new FormData(this);

  $form.find('[type="submit"]').removeClass('btn-icon').addClass('icon-right').append('<i class="fas fa-spinner fa-spin"></i>');

  formData.append('action', 'update_user_contact_preferences');
  formData.append('user_id', customSettings.current_user);

  $.ajax({
    url: customSettings.ajaxurl,
    method: 'POST',
    data: formData,
    processData: false,
    contentType: false,
    dataType: 'json',
    success: function(response) {
      $form.find('[type="submit"]').addClass('btn-icon').removeClass('icon-right');
      $form.find('[type="submit"] i').remove();

      if (response.status === 'success') {
        $form.append('<div class="submit-message success">'+response.message+'</div>');
      } else {
        $form.append('<div class="submit-message error">'+response.message+'</div>');
      }

      setTimeout(function() {
        $form.find('.submit-message').fadeOut();
      }, 3000);
    }
  });
});